


































import { Component, Prop, Vue } from 'vue-property-decorator';
import { PreCollection } from '@/resource/pre-collection/pre-collection.model';

@Component({
  components: {},
})
export default class PreCollectionTitle extends Vue {
  @Prop({ required: true })
  currentPreCollection!: PreCollection;

  viewOtherClick() {
    if (this.currentPreCollection) {
      const subjectName = this.currentPreCollection.subject.uuid;

      this.$router.push({
        path: `/browse`,
        query: {
          subject: subjectName,
        },
      });
    } else {
      this.$router.push({
        path: `/browse`,
      });
    }
  }
}
